import { Component, OnInit, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MemberQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { map } from 'rxjs/operators';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-benefits-page',
  templateUrl: './benefits-page.component.html',
  styleUrls: ['./benefits-page.component.scss'],
})
export class BenefitsPageComponent implements OnInit {
  name: Signal<string | undefined> = toSignal(
    this.memberQuery.selectMemberDetails().pipe(map((m) => (!!m ? `${m.FirstName} ${m.Surname}` : '')))
  );
  screenType = ScreenType;
  productCode = ProductCode;
  constructor(private memberQuery: MemberQuery) {}

  ngOnInit() {}
}
